import type { FC, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

export const AnimatedHeight: FC<{ children: ReactNode }> = ({ children }) => {
  const [height, setHeight] = useState<number>();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!contentRef.current) return;
    const observer = new ResizeObserver(([entry]) => setHeight(entry.borderBoxSize[0].blockSize));
    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={{
        height,
        "overflow": "hidden",
        "transition": "height 250ms ease-out",
        "@media (prefers-reduced-motion: reduce)": { transition: "none" },
      }}
    >
      <Box ref={contentRef}>{children}</Box>
    </Box>
  );
};
